export default "__VITE_ASSET__1cc88baa__"